export default {
  // Authentication

  RegisterCompanyWithManager: {
    CompanyNameExists:
      "Der eingegebene Firmenname ist bereits vergeben. Bitte wählen Sie einen anderen Firmennamen.",
    InvalidTaxId:
      "Die eingegebene UID- oder Steuer-Identifikationsnummer ist ungültig.",
    TaxIdExists:
      "Die eingegebene UID- oder Steuer-Identifikationsnummer wird bereits verwendet.",
    ManagerEmailExists:
      "Die eingegebene E-Mail-Adresse wird bereits verwendet. Wenn Sie bereits registriert sind, " +
      "loggen Sie sich ein. Ansonsten wählen Sie bitte eine andere E-Mail-Adresse.",
    InvalidPassword:
      "Ein Passwort muss aus mindestens 10 Zeichen bestehen und eine Zahl, " +
      "einen Groß- und Kleinbuchstaben, sowie ein Sonderzeichen beinhalten.",
    InvalidEmailAddress: "Die eingegebene E-Mail-Adresse ist ungültig.",
  },

  PublicResendActivationEmail: {
    ManagerNotFound:
      "Es konnte keine Aktivierungs-E-Mail versendet werden, da dieser Unternehmer nicht mehr existiert.",
    AlreadyConfirmed:
      "Sie haben Ihr Benutzerkonto, " +
      "welches mit der eingegebenen E-Mail-Adresse verknüpft ist, bereits aktiviert.",
    InvalidEmailAddress: "Die eingegebene E-Mail-Adresse ist ungültig.",
  },

  LoginAdminAccount: {
    InvalidCredentials: "Falsche E-Mail-Adresse oder falsches Passwort.",
    InvalidEmailAddress: "Die eingegebene E-Mail-Adresse ist ungültig.",
  },
  AssumeCompany: {
    // Currently no specific ErrorCode implemented
  },
  LoginManagerAccount: {
    InvalidCredentials: "Falsche E-Mail-Adresse oder falsches Passwort.",
    EmailNotConfirmed:
      "E-Mail-Adresse noch nicht bestätigt. " +
      "Klicken Sie auf den Bestätigungslink in Ihrer Aktivierungs-E-Mail " +
      "und versuchen Sie sich erneut einzuloggen. " +
      "Überprüfen Sie bitte zusätzlich den Spam-Ordner Ihres Postfaches.",
    AccountLocked:
      "Sie können sich nicht mehr einloggen, da Ihr Unternehmer-Account gesperrt wurde.",
    InvalidEmailAddress: "Die eingegebene E-Mail-Adresse ist ungültig.",
  },

  // Printer

  ConnectReceiptPrinter: {
    CashRegisterNotFound:
      "Dieser Drucker kann nicht verbunden werden, da die dazugehörige Kasse nicht mehr existiert.",
    CashRegisterNotPaired:
      "Diese Kasse ist derzeit mit keinem Endgerät verknüpft. " +
      "Verknüpfen Sie ein neues Gerät, um diese Aktion durchführen zu können.",
    PrinterAlreadyConnected:
      "Dieser Drucker wurde bereits mit der Kasse verbunden.",
  },
  SetDefaultReceiptPrinter: {
    CashRegisterNotFound:
      "Dieser Drucker kann nicht als Standarddrucker gesetzt werden, da die dazugehörige Kasse nicht mehr existiert.",
    CashRegisterNotPaired:
      "Diese Kasse ist derzeit mit keinem Endgerät verknüpft. " +
      "Verknüpfen Sie ein neues Gerät, um diese Aktion durchführen zu können.",
    PrinterNotFound:
      "Dieser Drucker kann nicht als Standarddrucker gesetzt werden, da dieser nicht mehr existiert.",
  },
  ChangeReceiptPrinterConfiguration: {
    CashRegisterNotFound:
      "Dieser Drucker kann nicht bearbeitet werden, da die dazugehörige Kasse nicht mehr existiert.",
    CashRegisterNotPaired:
      "Diese Kasse ist derzeit mit keinem Endgerät verknüpft. " +
      "Verknüpfen Sie ein neues Gerät, um diese Aktion durchführen zu können.",
    PrinterNotFound:
      "Dieser Drucker kann nicht bearbeitet werden, da dieser nicht mehr existiert.",
  },
  DisconnectReceiptPrinter: {
    CashRegisterNotFound:
      "Dieser Drucker kann nicht entfernt werden, da die dazugehörige Kasse nicht mehr existiert.",
    CashRegisterNotPaired:
      "Diese Kasse ist derzeit mit keinem Endgerät verknüpft. " +
      "Verknüpfen Sie ein neues Gerät, um diese Aktion durchführen zu können.",
    PrinterNotFound:
      "Dieser Drucker kann nicht entfernt werden, da dieser bereits entfernt wurde.",
  },

  // Contacts

  CreateContact: {
    InvalidEmail: "Die eingegebene E-Mail-Adresse ist ungültig.",
    InvalidTaxId:
      "Die eingegebene UID- oder Steuer-Identifikationsnummer ist ungültig.",
    InvalidCartDiscount: "Der eingegebene Warenkorbrabatt ist ungültig.",
    InvalidCashbackDiscount: "Das eingegebene Skonto ist ungültig.",
    InvalidIBAN: "Die eingegebene IBAN ist ungültig.",
    InvalidBIC: "Der eingegebene BIC ist ungültig.",
    ContactNumberExists: "Die eingegebene Kundennummer ist bereits vergeben.",
  },
  ChangeContact: {
    ContactNotFound:
      "Der Kunde konnte nicht bearbeitet werden, da dieser nicht mehr existiert.",
    InvalidEmail: "Die eingegebene E-Mail-Adresse ist ungültig.",
    InvalidTaxId:
      "Die eingegebene UID- oder Steuer-Identifikationsnummer ist ungültig.",
    InvalidCartDiscount: "Der eingegebene Warenkorbrabatt ist ungültig.",
    InvalidCashbackDiscount: "Das eingegebene Skonto ist ungültig.",
    InvalidIBAN: "Die eingegebene IBAN ist ungültig.",
    InvalidBIC: "Der eingegebene BIC ist ungültig.",
    ContactNumberExists: "Die eingegebene Kundennummer ist bereits vergeben.",
  },
  DeleteContact: {
    ContactNotFound: 'Der Kunde "%s" wurde bereits gelöscht.',
  },

  CreatePersonInCharge: {
    ContactNotFound: "Der referenzierte Kunde existiert nicht mehr.",
    InvalidDateOfBirth:
      "Ein Geburtsdatum eines lebenden Ansprechpartners kann nicht in der Zukunft liegen.",
    InvalidEmail: "Die eingegebene E-Mail-Adresse ist ungültig.",
  },
  ChangePersonInCharge: {
    ContactPersonInChargeNotFound:
      "Der Ansprechpartner konnte nicht bearbeitet werden, da dieser nicht mehr existiert.",
    ContactNotFound: "Der referenzierte Kunde existiert nicht mehr.",
    InvalidDateOfBirth:
      "Ein Geburtsdatum einer lebenden Person kann nicht in der Zukunft liegen.",
    InvalidEmail: "Die eingegebene E-Mail-Adresse ist ungültig.",
  },
  DeletePersonInCharge: {
    ContactPersonInChargeNotFound:
      'Der Ansprechpartner "%s" wurde bereits gelöscht.',
    ContactNotFound: "Der referenzierte Kunde existiert nicht mehr.",
  },

  CreateShippingAddress: {
    ContactNotFound: "Der referenzierte Kunde existiert nicht mehr.",
  },
  ChangeShippingAddress: {
    ContactShippingAddressNotFound:
      "Die Lieferadresse konnte nicht bearbeitet werden, da diese nicht mehr existiert.",
    ContactNotFound: "Der referenzierte Kunde existiert nicht mehr.",
  },
  DeleteShippingAddress: {
    ContactShippingAddressNotFound:
      'Die Lieferadresse "%s" wurde bereits gelöscht.',
    ContactNotFound: "Der referenzierte Kunde existiert nicht mehr.",
  },

  CreateDepartment: {
    ContactNotFound: "Der referenzierte Kunde existiert nicht mehr.",
  },
  ChangeDepartment: {
    ContactDepartmentNotFound:
      "Die Abteilung konnte nicht bearbeitet werden, da diese nicht mehr existiert.",
    ContactNotFound: "Der referenzierte Kunde existiert nicht mehr.",
  },
  DeleteDepartment: {
    ContactDepartmentNotFound: 'Die Abteilung "%s" wurde bereits gelöscht.',
    ContactNotFound: "Der referenzierte Kunde existiert nicht mehr.",
  },

  // Receipts

  SendReceiptPerMail: {
    ReceiptNotFound:
      "Der Beleg kann nicht versendet werden, da dieser nicht mehr existiert.",
    InvalidEmailAddress: "Die eingegebene E-Mail-Adresse ist ungültig.",
  },
} as const
